// This must be persistent across restarts/reloads.
// FIFO cache implemented, with fixed size (might make that configurable)
// Need a dump method to get entire cache, then clear it.
// UI will then take this and make a file for user to download, which they send to us.
// Use IndexedDB in browser, as it is origin based and can handle lots of data.
// localStorage is inappropriate because it isn't safe. sessionStorage isn't appropriate
// because it is cleared when session is closed (and session closing is one of the thing
// we want to trouble shoot).
import { openDB } from 'idb';
import { getLogSizes, isCachingAvailable } from './predicates';
var CacheName;
(function (CacheName) {
    CacheName["database"] = "cached-logs";
    CacheName["table"] = "logs";
})(CacheName || (CacheName = {}));
const cacheSize = getLogSizes();
async function getLogDb() {
    if (!isCachingAvailable()) {
        // Can't use IndexedDB
        const msg = [
            'Attempting to use browser cached logging, but IndexedDB is not supported.',
            'Either a non-standard browser is being used or you are attempting to use this in Node.',
        ].join(' ');
        console.warn(msg);
        return null;
    }
    const logDb = await openDB(CacheName.database, 1, {
        upgrade(db, oldVersion) {
            switch (oldVersion) {
                case 0: {
                    db.createObjectStore(CacheName.table, {
                        keyPath: 'id',
                        autoIncrement: true,
                    });
                }
            }
        },
    });
    return logDb;
}
export async function push(message) {
    const logDb = await getLogDb();
    if (!logDb) {
        return;
    }
    const id = await logDb.add(CacheName.table, { message });
    // Tried to batch the calls to delete using a buffer. It didn't
    // work. Lots of calls took place. I.e. there is no difference
    // in this code and code that used a buffer and used a flag
    // to indicate a delete was going on. This is simplest.
    const count = await logDb.count(CacheName.table);
    if (count > cacheSize) {
        // console.log('*** clean up old logs', {
        //   count,
        //   cacheSize,
        //   id,
        //   oldestId: +id - cacheSize,
        // });
        await logDb.delete(CacheName.table, IDBKeyRange.upperBound(+id - cacheSize));
    }
}
export async function clear() {
    const logDb = await getLogDb();
    if (!logDb) {
        return;
    }
    await logDb?.clear(CacheName.table);
}
export async function dump() {
    const logDb = await getLogDb();
    if (!logDb) {
        return 'Caching of log messages is unavailable';
    }
    const allLogMessages = await logDb.getAll(CacheName.table);
    await logDb.clear(CacheName.table);
    const log = (allLogMessages || []).map((e) => e.message).join('\n');
    return log;
}
//# sourceMappingURL=cache.js.map